export default "__VITE_ASSET__38f58938__"